<template>
  <!-- 账单详情 -->
  <div class="page-container">
    <el-form id="invoiceTable" class="form-panel" label-position="top" >
      <el-row class="content-panel position-parent">
        <span class="position-title">业务信息</span>
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="订单号:">
              <el-input style="width: 100%;"
                        class="input_length"
                        v-model="ebOrder.orderNo"
                        :title="ebOrder.orderNo"
                        clearable
                        size="mini"
                        disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="提单号:">
              <el-input style="width: 100%;"
                        class="input_length"
                        v-model="ebOrder.mblNo"
                        :title="ebOrder.mblNo"
                        clearable
                        size="mini"
                        disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="客户业务编号:">
              <el-input style="width: 100%;"
                        class="input_length"
                        v-model="ebOrder.custBizNo"
                        :title="ebOrder.custBizNo"
                        clearable
                        size="mini"
                        disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-row :gutter="2">
              <el-col :span="16">
                <el-form-item label="船名:">
                  <el-input style="width: 100%;"
                            class="input_length"
                            v-model="ebOrder.realVesselNameEn"
                            :title="ebOrder.realVesselNameEn"
                            clearable
                            size="mini"
                            disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="航次:">
                  <el-input style="width: 100%;"
                            class="input_length"
                            v-model="ebOrder.realVoyage"
                            :title="ebOrder.realVoyage"
                            clearable
                            size="mini"
                            disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <el-form-item label="ETD:">
              <el-input style="width: 100%;"
                        class="input_length"
                        v-model="ebOrder.etd"
                        :title="ebOrder.etd"
                        clearable
                        size="mini"
                        disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item label="委托公司:">
              <el-input style="width: 100%;"
                        class="input_length"
                        v-model="ebOrder.custName"
                        :title="ebOrder.custName"
                        clearable
                        size="mini"
                        disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="  ">
             <span
               style="
                          margin: 2%;
                          width: 100%;
                          word-break: break-word;
                          color: red;
                        "
             >{{currencyAmount}}</span
             >
            </el-form-item>
          </el-col>

        </el-row>
      </el-row>
      <!-- 按钮栏-start -->
          <el-row style="background-color:#fff;padding:10px">
            <el-button class="el-button-search" type="primary" size="small" plain @click="invoiceDetailPrint"
            >打印
            </el-button
            >
            <el-button type="primary" size="small" plain @click="invoiceDetailExcel"
            >导出
            </el-button
            >
          </el-row>
        <!-- 按钮栏-end -->
      <el-row class="content-panel position-parent" style="margin-top:10px">
        <span class="position-title">费用信息</span>
        <el-row>
          <el-col span="24">
            <hot-table
              ref="invoicesDetailsRef"
              :data-source="billList"
              :settings="invoicesSettings"
              >
              <hot-column :has-tip="true" data="freightNameCn" title="费用名称" width="100"></hot-column>
              <hot-column :has-tip="true" data="unitPrice" title="单价" width="100"></hot-column>
              <hot-column :has-tip="true" data="quantity" title="数量" width="100"></hot-column>
              <hot-column :has-tip="true" data="unitName" title="单位" width="50"></hot-column>
              <hot-column :has-tip="true" data="settleAmount" title="金额" width="100"></hot-column>
              <hot-column :has-tip="true" data="settleCurrencyCode" title="币种" width="100"></hot-column>
              <hot-column :has-tip="true" data="invoiceNo" title="增值税发票号" width="200"></hot-column>
              <hot-column :has-tip="true" data="onceInvoiceNo" title="一次发票号" width="300" ></hot-column>
              <hot-column :has-tip="true" data="compNo" title="对账单号" width="100"></hot-column>
              <hot-column :has-tip="true" data="auditDate" title="审核日期" width="100" date-format="YYYY-MM-DD" ></hot-column>
            </hot-table>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
    <el-dialog
      :visible.sync="mdReportTemplateVisible"
      title="打印"
      :append-to-body="true"
      :close-on-click-modal="true"
      width="70%"
    >
      <el-row>
        <el-button class="el-button-search" type="primary" size="small" plain @click="preview()" >预览</el-button>
        <el-button class="el-button-search" type="primary" size="small" plain   >打印</el-button>
      </el-row>
      <el-row style="margin-top: 15px;margin-bottom: 20px;height: 300px">
        <hot-table
          ref="mdReportTemplateTableRef"
          :data-source="mdReportTemplateData"
          col-settings-key="onlineServiceDialogTable"
        >
          <hot-column :has-tip="true" data="templateNameCn" title="套版名称" width="150"></hot-column>
        </hot-table>
        <!-- 分页start -->
        <!-- 分页end -->
      </el-row>
      </el-dialog>
  </div>
</template>

<script>
import { queryWebInvoice } from "@/api/queryMainSystem";
import { getOrderdata } from "@/api/bookingRequest";
import {getEbOrderByGoOrderId} from "@/api/ebOrder";
import ebOrder from "@/api/ebOrder";
import {downloadExcel} from "@/utils/downloadExcel";
import { queryMdReportTemplate } from "@/api/common";
import { export_json_to_excel } from "@/vendor/Export2Excel";
import Xlsx from 'xlsx'

export default {
  name: "orderInvoiceDetails",
  data() {
    return {
     mdReportTemplateVisible: false,
      summarize: "",
      currencyAmount:null,
      activeNames: [],
      invoicesList: [],
      billList: [],
      mdReportTemplateData: [],
      invoices: [{
        settleAmount: "",
        settleCurrencyCode: "",
        frCommitDate: "",
        allocableAmount: "",
        invoiceTitleId: "",
        invoiceType: "",
        details: [{
          settleAmount: "",
          settleCurrencyCode: "",
          invoiceTitleId: "",
          freightNameCn: "",
          onceInvoiceNo: "",
          rpFlag: "",
        }],
        onceInvoiceNo: "",
        invoiceTitleName: "",
        rpFlag: "",
        issuedDate: "",
      }],
      ebOrder: {

      },
      invoicesSettings: {
        height: 320,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig
      },
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
    }
  },
  mounted() {
    let self = this;
    let mblNo = self.$route.params.mblNo;
    let bcPublicOrderId = self.$route.params.bcPublicOrderId;
    let ebOrderId = self.$route.params.ebOrderId;
    let type = self.$route.params.type;
    let goOrderId = self.$route.params.goOrderId;
    self.activeNames.push("1");
    if (goOrderId !== null &&
      goOrderId !== undefined) {
      self.queryForm(goOrderId, bcPublicOrderId);
    }
    if (goOrderId !== null && goOrderId !== undefined) {
      self.queryEbOrder(goOrderId);
    }
    // let webInvoice = sessionStorage.getItem("webInvoice");
    // if (webInvoice !== null && webInvoice !== undefined) {
    //   self.invoicesList = JSON.parse(webInvoice);
    // }
    this.invoicesSettings.height = document.body.clientHeight - 100 - 180;
  },
  watch: {
  },
  methods: {
    handleChange(val) {
    },
    queryForm(goOrderId, bcPublicOrderId) {
      let self = this;
      let searchData = {};
      searchData.currentPage = self.pageConfig.currentPage;
      searchData.pageSize = self.pageConfig.pageSize;
      searchData.goOrderId = goOrderId;
      searchData.bcPublicOrderId = bcPublicOrderId;
      searchData.queryType = "detail";
      let currenCodeMap = new Map();
      queryWebInvoice(searchData).then((res) => {
        if (res.details) {
          res.details.forEach((item) => {
            if(currenCodeMap.get(item.settleCurrencyCode)){
              currenCodeMap.set(item.settleCurrencyCode,new Number((currenCodeMap.get(item.settleCurrencyCode)).valueOf() + (new Number(item.settleAmount)).valueOf()));
            }else {
              currenCodeMap.set(item.settleCurrencyCode,new Number(item.settleAmount));
            }
            item.issuedDate = self.$moment(item.issuedDate).format("yyyy-MM-DD HH:mm:ss");
            item.cancelledDate = self.$moment(item.cancelledDate).format("yyyy-MM-DD HH:mm:ss");
            item.frCommitDate = self.$moment(item.frCommitDate).format("yyyy-MM-DD HH:mm:ss");
            item.auditDate = new Date(parseInt(item.auditDate.time));
          });
          self.billList = res.details;
          if(currenCodeMap.size>0){
            let currencyCodeList = [];
            currenCodeMap.forEach((value, key) => {
              currencyCodeList.push(key+":"+value.toFixed(2));
            })
            self.currencyAmount = currencyCodeList.join(";");
          }
        }
      });
    },
    queryEbOrder(goOrderId) {
         let self = this;
      getEbOrderByGoOrderId(goOrderId).then((res) => {
        if (res.success == true && res.data.length == 1 ) {
          self.ebOrder = res.data[0];
          self.ebOrder.etd = self.$moment(ebOrder.etd).format("yyyy-MM-DD HH:mm:ss");
        }
      });

    },
    invoiceDetailExcel(){
      var  selectData = []
        if(this.$refs.invoicesDetailsRef.getSelections().length>0){
          selectData = this.$refs.invoicesDetailsRef.getSelections()
        }else{
          if(this.billList.length>0){
            selectData = this.billList
          }
        }

        var bcFreightIds = []
        for(var a in selectData){
          bcFreightIds.push(selectData[a].bcFreightId)
        }

        var tableCol =this.$refs.invoicesDetailsRef.$children
        var str =''
        var head = ''
        for(var i=0; i<tableCol.length-2; i++){
          str+= tableCol[i].columnSettings.data
          head+= tableCol[i].columnSettings.title
          if(i!==tableCol.length-3){
            str+=','
            head+=','
          }
        }

       var strs = str.split(',');
       var heads = head.split(',');
       var data = selectData.map((a) => strs.map((b) => a[b]));
       var date = this.currentTime();
       var fileName = "InvoiceFreightDetail" + date;
       export_json_to_excel({
        header: heads,// 表头
        data: data, // 数据列表
        filename: fileName,// 保存文件名
      });
        //window.location.origin
       // var url = process.env.VUE_APP_BASE_API+'/web/daoService/excelExport/custom-sql/cts-web/CTS_ILP_WebExportInvoiceFreightDetail/web'
       // let reqArgs = {
       //   bcFreightId: bcFreightIds
       // }
       // if(bcFreightIds.length>0){
       //   downloadExcel(reqArgs,str,url,'InvoiceFreightDetail')
       // }else{
       //   self.$coreMethods.message('warn',this.$t('message.unableToExport'))
       // }
    },
    currentTime() {
            var date = new Date();
            var year = date.getFullYear(); //月份从0~11，所以加一
            let month = date.getMonth();
            console.log("month",month);
            var dateArr = [
                date.getMonth() + 1,
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds(),
            ];
            //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
            for (var i = 0; i < dateArr.length; i++) {
                if (dateArr[i] >= 1 && dateArr[i] <= 9) {
                    dateArr[i] = "0" + dateArr[i];
                }
            }
            var strDate =
                year +
                "/" +
                dateArr[0] +
                "/" +
                dateArr[1] +
                " " +
                dateArr[2] +
                ":" +
                dateArr[3] +
                ":" +
                dateArr[4];
                //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
               	//this.date = strDate;
            return strDate;
        },
    invoiceDetailPrint(){
        let self = this;
        var  selectData = []
        if(this.$refs.invoicesDetailsRef.getSelections().length>0){
          selectData = this.$refs.invoicesDetailsRef.getSelections();
          var bcFreightIds = "";
          for(var a in selectData){
            if(a < selectData.length - 1){
              bcFreightIds += selectData[a].bcFreightId + ",";
            }else{
              bcFreightIds += selectData[a].bcFreightId;
            }
          }
          this.reportPrimaryId = bcFreightIds;
          this.mdReportTemplateVisible= true;
          let searchData = {
            apiKey : "CTS_ILP_MdReportTemplate",
            sqlKey: "CTS_ILP_MdReportTemplate",
            tag: "CTS_ILP_MdReportTemplate",
            reqArgs: {"templateTypeCode": "OLS_BMS_FREIGHT"},
            action: "query",
            returnTotal: false
          }
          queryMdReportTemplate(searchData).then((res) => {
            if (res.success == true ) {
              this.mdReportTemplateData = res.data;
              if (res.data.length === 0){
                this.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
              }else {
                this.$coreMethods.message("success", "查询成功！");
              }
            }
          });
        }else {
          this.$coreMethods.message("warning", "请勾选一条数据！");
        }
      },
      preview(){
        let self = this;
        if(this.$refs.mdReportTemplateTableRef.getSelections().length==1){

          if(this.$refs.mdReportTemplateTableRef.getSelected().reportUrl==null){
            this.$coreMethods.message("error", "报表路径错误，请检查！");
            return;
          }

          this.mdReportTemplateVisible= false;
          this.$router.push({
            name: "reportShow",
            query: {
              systemType: this.$refs.mdReportTemplateTableRef.getSelected().systemType,
              reportUrl: this.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
              primaryId: this.reportPrimaryId
            }
          });
        }else {
          this.$coreMethods.message("warning", "请勾选一条数据！");
        }
      },
  }
}
</script>

<style scoped lang="scss">
.position-parent {
  position: relative;
}

.position-title {
  position: absolute;
  top: -7px;
  background: #ffffff;
  padding: 0 4px;
}
</style>
